module.exports = __webpack_public_path__ + "static/media/icono_editar_perfil_blanco.84cda335.svg";